export default __webpack_public_path__ + "static/24-e37a9391d2ba066ec0e2aac9f43985db.webp";